// extracted by mini-css-extract-plugin
module.exports = {"container":"NewEntry_container__2VprE"};